import { InjectionToken } from '@angular/core';

/**
 * `InjectionToken` representing native javascript window object
 */
export const WINDOW: InjectionToken<string> = new InjectionToken('WINDOW');
